export class SurveysMessages {
  public static readonly SURVEY = 'surveys.survey';
  public static readonly SURVEYS = 'surveys.surveys';
  public static readonly MANAGE_SURVEY_ADMINS = 'surveys.manage-survey-admins';
  public static readonly MANAGE_SURVEY_ADMINS_DESCRIPTION = 'surveys.manage-survey-admins-description';
  public static readonly MANAGE_SURVEY_ADMINS_DESCRIPTION_SHORT = 'surveys.manage-survey-admins-description-short';
  public static readonly CURRENT_SURVEY_ADMINS = 'surveys.current-survey-admins';
  public static readonly MANAGE_SURVEY_ADMINS_SUCCESS = 'surveys.manage-survey-admins-success';
}